import logger from "./logger";

export class Mousemove {
	static isMouseMoved = false;
	static listenerAdded = false;

	static init() {
		if (!this.listenerAdded) {
			this.listenerAdded = true;
			document.addEventListener('mousemove', this.checkMM);
			document.addEventListener('mousedown', this.checkMM);
			document.addEventListener('keydown', this.checkMM);
			document.addEventListener('touchmove', this.checkMM);
			document.addEventListener('touchstart', this.checkMM);
			document.addEventListener('touchend', this.checkMM);

			setInterval(function () {
				fetch(URL_API('tok', 'user'), {
					method: 'post',
					headers: {'Content-type': 'application/json; charset=UTF-8', "X-Custom-Token": "soneXasdomVavue123"}
				})
					.then(response => response.json())
					.then(data => {
						if (data.hasOwnProperty('tok')) {
							$("#cftoken1").val(data.tok);
							let t = $("#cftoken").val();
							if (t !== '') {
								$("#cftoken").val(data.tok);
							}
						}
					})
			}, 270000); //4:30 minutes
		}
	}

	static checkMM(e) {
		if (!e.isTrusted) {
			logger.warn('Synthetic (fake) event detected, ignoring.');
			return;
		}
		if (!this.isMouseMoved) {
			let t = $("#cftoken1").val();
			$("#cftoken").val(t);
			this.isMouseMoved = true;
			document.removeEventListener('mousemove', this.checkMM);
			document.removeEventListener('mousedown', this.checkMM);
			document.removeEventListener('keydown', this.checkMM);
			document.removeEventListener('touchmove', this.checkMM);
			document.removeEventListener('touchstart', this.checkMM);
			document.removeEventListener('touchend', this.checkMM);
		}
	}
}
